import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import {
    Box,
    Grid,
    styled,
    Typography
} from '@mui/material';

import CardStyle from "../../../shared/general/Card";

import { getSettingStepTime } from "../../../../../actions/requestTime";

const Root = styled("div")({
    marginTop: "30px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
});

const Header = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const StyledValue = styled(Box)({
    padding: "8px 16px",
    borderRadius: "8px",
    backgroundColor: "#f5f5f5",
    minWidth: "120px",
    textAlign: "center",
});

const SettingOT = ({ company }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const OT_ROUND_OPTIONS = [
        { value: 1, label: t("EveryMinute") },
        { value: 15, label: `15 ${t("Minute")}` },
        { value: 30, label: `30 ${t("Minute")}` },
    ];
    const { result: userProfile } = useSelector(state => state.userProfile);
    const { result: settingOT } = useSelector(state => state.settingOT);

    useEffect(() => {
        if(userProfile && company){
            dispatch(getSettingStepTime({ idCompany: company.idCompany }));
        }
    },[userProfile, company]);

    const getStepTimeOT = () => {
      if(settingOT && settingOT.stepTimeOT && Number.isInteger(settingOT.stepTimeOT)){
        return settingOT.stepTimeOT;
      }
      return 1;
    };

    const selectedOption = OT_ROUND_OPTIONS.find((option) => option.value === getStepTimeOT());

    return (
        <Root>
            <Header>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Typography variant="h6">{t("OvertimeSetting")}</Typography>
                    </Grid>
                </Grid>
            </Header>
            <CardStyle style={{ padding: 24 }}>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                    <Grid item>
                        <Typography fontSize="16px" fontWeight="500">
                            {t("OvertimeCountingInterval")}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <StyledValue>
                            <Typography fontSize="16px" fontWeight="600">
                                {selectedOption ? selectedOption.label : `${getStepTimeOT()} ${t("Minute")}`}
                            </Typography>
                        </StyledValue>
                    </Grid>
                </Grid>
            </CardStyle>
        </Root>
    );
};

export default SettingOT;
